// sort-imports-ignore
import { ToastContainer, toast } from "react-toastify";
import { CheckIcon, InfoCircleIcon, WarningIcon } from "../../Icons";
import CrossIcon from "../../Icons/CrossIcon";

import "react-toastify/dist/ReactToastify.css";
import "./ToastContainer.css";

const DEFAULT_OPTIONS = {
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  autoClose: 3000,
};

const Component = ({ ...props }) => {
  return <ToastContainer position="top-center" {...DEFAULT_OPTIONS} {...props} />;
};

export const toastSuccess = (text: string) =>
  toast.success(text, {
    ...DEFAULT_OPTIONS,
    icon: <CheckIcon color={"#007681"} />,
    position: "top-center",
    className: "!bg-[#CCE4E6] !border-[#99C8CD] !text-[#007681]",
    closeButton: (
      <button className="text-[#007681]">
        <CrossIcon width={14} height={14} />
      </button>
    ),
  });

export const toastInfo = (text: string) =>
  toast.info(text, {
    ...DEFAULT_OPTIONS,
    icon: <InfoCircleIcon color={"#144E89"} />,
    position: "top-center",
    className: "!bg-[#E3F2FC] !border-[#8FCAF5] !text-[#144E89]",
    closeButton: (
      <button className="text-[#144E89]">
        <CrossIcon width={14} height={14} />
      </button>
    ),
  });

export const toastError = (text: string) =>
  toast.error(text, {
    ...DEFAULT_OPTIONS,
    icon: (
      <span className="rounded-full bg-[#BF0002]">
        <CrossIcon color={"#FFEAED"} />
      </span>
    ),
    position: "top-center",
    className: "!bg-[#FFEAED] !border-[#F59692] !text-[#BF0002]",
    closeButton: (
      <button className="text-[#BF0002]">
        <CrossIcon width={14} height={14} />
      </button>
    ),
  });

export const toastWarning = (text: string) =>
  toast.warning(text, {
    ...DEFAULT_OPTIONS,
    icon: <WarningIcon color={"#FFB100"} />,
    position: "top-center",
    className: "!bg-[#FFF8E1] !border-[#FFE082] !text-[#FFB100]",
    closeButton: (
      <button className="text-[#FFB100]">
        <CrossIcon width={14} height={14} />
      </button>
    ),
  });

export default Component;
